import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import UpdatePassword from './pages/UpdatePassword';
import Dashboard from './pages/Dashboard';
import Colleges from './pages/Colleges';
import News from './pages/News';
import Events from './pages/Events';
import Hackathons from './pages/Hackathons';
import Achievements from './pages/Achievements';
import Gallery from './pages/Gallery';
import Coordinators from './pages/Coordinators';
import Projects from './pages/Projects';
import Contacts from './pages/Contacts';
import logo from "./components/MMPSRPC_Logo.svg";
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-teal-600">
        <div className="relative">
          <img src={logo} alt="MMPSRPC Logo" className="w-32 h-32 animate-pulse" />
          <div className="absolute inset-0 animate-ping">
            <div className="absolute inset-0 bg-yellow-300 opacity-75 rounded-full scale-0 animate-ripple"></div>
            <div className="absolute inset-0 bg-yellow-300 opacity-75 rounded-full scale-0 animate-ripple animation-delay-300"></div>
            <div className="absolute inset-0 bg-yellow-300 opacity-75 rounded-full scale-0 animate-ripple animation-delay-600"></div>
          </div>
        </div>
      </div>
    );
  }

  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/update-password" element={<PrivateRoute><UpdatePassword /></PrivateRoute>} />
          <Route path="/colleges" element={<PrivateRoute><Colleges /></PrivateRoute>} />
          <Route path="/news" element={<PrivateRoute><News /></PrivateRoute>} />
          <Route path="/events" element={<PrivateRoute><Events /></PrivateRoute>} />
          <Route path="/hackathons" element={<PrivateRoute><Hackathons /></PrivateRoute>} />
          <Route path="/achievements" element={<PrivateRoute><Achievements /></PrivateRoute>} />
          <Route path="/gallery" element={<PrivateRoute><Gallery /></PrivateRoute>} />
          <Route path="/coordinators" element={<PrivateRoute><Coordinators /></PrivateRoute>} />
          <Route path="/projects" element={<PrivateRoute><Projects /></PrivateRoute>} />
          <Route path="/contacts" element={<PrivateRoute><Contacts /></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;